import React from 'react'
import Password from './Password'
import Rest from './Rest'
import Blog from './Blog'
import SocialMedia from './SocialMedia'
import { Errors } from '../../../../partials/Partials'

function Other({errors}) {
    return (
        <div id="other" className="section">
            <Errors errors={errors} />
            <Password />
            <Rest />
            <Blog />
            <SocialMedia />
        </div>
    )
}

export default Other